import { useEffect, useState } from 'react';

const getMatches = (query, defaultValue) => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return defaultValue;
    }

    return window.matchMedia(query).matches;
};

export default function useMediaQuery(query, defaultValue = false) {
    const [matches, setMatches] = useState(() => getMatches(query, defaultValue));

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            return undefined;
        }

        const mediaQueryList = window.matchMedia(query);
        const handleChange = () => setMatches(mediaQueryList.matches);

        handleChange();

        if (typeof mediaQueryList.addEventListener === 'function') {
            mediaQueryList.addEventListener('change', handleChange);
            return () => mediaQueryList.removeEventListener('change', handleChange);
        }

        mediaQueryList.addListener(handleChange);
        return () => mediaQueryList.removeListener(handleChange);
    }, [query]);

    return matches;
}
